import { useDocumentTitle } from 'usehooks-ts';
import { PageHeader } from '../../tailwindComponents/PageHeader';
import { NetworkRatesSection } from './NetworkRatesSection';

// The per-vehicle tariff accordion (Postcode / Day Rate / Multistop / Additional FTL
// cards per fleet category) is hidden alongside the fleet-availability feature — the
// page is network tariffs only for now. The AddTariff/EditTariff forms and routes
// remain for when vehicle rates resurface under Fleet Vehicles / Rates.
export function PriceMaster() {
  useDocumentTitle('FLOX - Network Tariffs');

  const pages = [
    { name: 'Home', href: '/', current: false },
    { name: 'Network Tariffs', href: '/transport-price-master', current: true },
  ];

  return (
    <>
      <PageHeader header='Network Tariffs' pages={pages} />
      <main className='flex flex-col gap-4 min-h-[calc(100vh-4rem)] lg:min-h-[calc(100vh-5rem)] p-4 lg:pt-4 lg:px-8 lg:pb-8 relative'>
        <NetworkRatesSection />
      </main>
    </>
  );
}
